export const TempErrorFrontService: string =
  "Error respuesta Front-end PDP: Fallo al consumir el servicio (%s) [0010002]";
export const TempErrorGatewayService: string =
  "Error respuesta Gateway PDP: Fallo al consumir el servicio (%s) [0010002]";
export const TempErrorFrontSimple: string = "Error respuesta Front-end PDP: %s";
export const TempErrorFrontUser: string = "Error respuesta para usuario: %s";
export const TempErrorFront: string = "Error respuesta %s: %s";
